import Vue from 'vue';
import VueCookie from 'vue-cookie';
import { MutationTree } from 'vuex';
import { UserInfo, CourseModel } from '@descomplica/dex-models';
import { UserState } from './state';
import Analytics from '@/helpers/analytics';
import { getCourseCategory } from '@/helpers/category';

const mutations: MutationTree<UserState> = {
  SET_USER(state, user: UserInfo) {
    if (state.user && state.user.email === user.email) {
      state.user = { ...state.user, ...user };
    } else {
      state.user = user;
    }
  },
  SET_USERS(state, entities: UserState) {
    Object.values(entities.users || {}).forEach((user) => {
      Vue.set(state.users, user.id.toString(), {
        ...state.users[user.id],
        ...user,
      });
    });
  },
  SET_TOKEN(state, token: string) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  SET_SHOW_DUE_DATE_WARNING(state, value: boolean) {
    state.showDueDateWarning = value;
  },
  SET_SHOULD_DISPLAY_SOCIAL_METAVERSE(state, value: boolean) {
    state.shouldDisplaySocialMetaverse = value;
  },
  SET_SHOW_POSTGRAD_ASSESSMENTS_CARD(state, value: boolean) {
    state.showPostgradAssessmentsCard = value;
  },
  SET_SHOW_POSTGRAD_TCC_ASSESSMENT(state, value: boolean) {
    state.showPostgradTCCAssessment = value;
  },
  SET_CAN_VIEW_TERMS_OF_USE(state, value: boolean) {
    state.canViewTermsOfUse = value;
  },
  SET_CURRENT_COURSE(state, course: CourseModel) {
    state.currentCourse = course;
    if (course) {
      Analytics.updateUserCourses({
        name: course.name,
        category: getCourseCategory(course),
      });
    }
  },
  SIGNOUT(state) {
    localStorage.clear();
    VueCookie.delete('d', { domain: '.descomplica.com.br' });

    mutations.SET_USER(state, {});
    state.token = undefined;
  },
  SET_CAN_VIEW_POSTGRAD_STUDY_PLANNING(state, isFeatureEnabledForUser: boolean) {
    state.canViewPostgradStudyPlanning = isFeatureEnabledForUser;
  },
  SET_SHOULD_DISPLAY_PUBLIC_VIDEO_NOTES(state, value: boolean) {
    state.shouldDisplayPublicVideoNotes = value;
  },
  SET_CAN_VIEW_UNDERGRAD_CLASSROOMS_GRADES(state, value: boolean) {
    state.canViewUndergradClassroomsGrades = value;
  },
  SET_SHOULD_SHOW_EQUAL_WEB_WIDGET(state, value: boolean) {
    state.shouldShowEqualWebWidget = value;
  },
  SET_SHOULD_DISPLAY_PERIODS_RENAMED(state, value: boolean) {
    state.shouldDisplayPeriodsRenamed = value;
  },
  SET_GRADE_ACTIVITIES_VIA_AI(state, value: boolean) {
    state.gradeActivitiesViaAi = value;
  },
  SET_CAN_VIEW_POSTGRAD_CONTRACT_EXTENSION_BUTTON(state, value: boolean) {
    state.canViewPostgradContractExtensionButton = value;
  },
  SET_CAN_VIEW_POSTGRAD_STUDENT_DOCUMENTS(state, value: boolean) {
    state.canViewPostgradStudentDocuments = value;
  },
  SET_CAN_VIEW_POSTGRAD_CERTIFICATE(state, value: boolean) {
    state.canViewPostgradCertificate = value;
  },
  SET_SHOULD_GET_TRIAL(state, value: boolean) {
    state.shouldGetTrial = value;
  },
};

export default mutations;
